import React from 'react';
import { Icon, Button, Input, Form, Modal } from 'components';
import { CreateAccountForm } from 'control-components';
import {  useSelect, useAction, useModal } from 'hooks';
import { withForm, withFormValidation } from 'hoc';
import { Link, useHistory } from 'react-router-dom';

const initState = {
  email: '',
  password: '',
  password_confirmation: '',
  first_name: '',
  middle_name: '',
  extension_name: '',
  last_name: '',
  gender: '',
  birth_date: '',
  terms_and_condition: '',
  mobile_number: ''
}

function SignUp({  onChange, onSetForm , onSwitch, value, helperMessage, isPassed }) {
  const history = useHistory()
  const [isOpen, onOpen, onClose] = useModal()
  const registering = useSelect('loading.isLoading', { type: 'auth.register' })
  const register = useAction('auth.register');

  const handleSubmit = e => {
    e.preventDefault()
    register(value, () => {
      localStorage.removeItem('otp_running_seconds')
      history.replace({
        pathname: '/otp',
        state: {
          mobile_number: value.mobile_number,
          password: value.password,
          url: '/sign-up'
        }
      })
      // onSetForm(initState)
      // onOpen()
    })
  }

  return (
    <>
      <div className="signup-container">
        <div className="form-container">
          <Form className="form w-full flex flex-grow" onSubmit={handleSubmit}>
            <div className="xl:!hidden lg:!hidden flex flex-col items-center justify-center flex-grow">
              <Icon.Logo className="lw-36 h-36"/>
              <span className="text-xs text-center">Land Transportation Franchising & Regulatory Board</span>
              <span className="text-sm font-bold text-center">Online Application and Issuance of Certificate of Public Convenience</span>
            </div>
            <div className="hidden xl:flex lg:flex flex-grow justify-center">
              <Icon.Logo className="lw-36 h-36"/>
            </div>
            <div className="flex xl:!pb-10 pb-3">
            <Link to="/" className="w-full h-16 flex text-black items-center justify-center"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Guidelines</span></Link>
              <Link to="/login" className="w-full h-16 flex text-black items-center justify-center"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Sign In</span></Link>
              <Link to="/sign-up" className="w-full h-16 flex text-black items-center justify-center rounded-none border-b-4 border-warning"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Create Account</span></Link>
            </div>
            <CreateAccountForm value={value} onChange={onChange} helperMessage={helperMessage}/>
            <div className="inline-flex items-center justify-center">
              <label htmlFor='terms_and_condition' className="flex items-center space-x-2">
                <div>
                  <Input type="checkbox" id="terms_and_condition" name="terms_and_condition" value={value.terms_and_condition} onChange={onSwitch} />
                </div>
                <p className="text-sm text-skin-primary flex-1 whitespace-pre-line">I AGREE with the LTFRB Privacy Notice and give my consent to the collection and processing of my personal data in accordance thereto.</p>
              </label>

            </div>
            <Button
              isLoading={registering}
              disabled={!isPassed}
              className="!bg-warning !text-black h-12 xl:!mt-10 mt-3"
            >
              <span>Sign Up</span>
            </Button>
            <Link to="/login" className="forgot-password-link">Sign In</Link>
          </Form>
        </div>
        <div className="brand xl:!flex lg:!flex !hidden">
          <div className="content">
            <span className="title">Land Transportation Franchising & Regulatory Board</span>
            <span className="sub-title">Online Application and Issuance of Certificate of Public Convenience</span>
          </div>
        </div>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="flex">
          <div className="m-auto flex flex-col items-center space-y-3">
            <Icon.Check className="!w-20 !h-20"/>
            <p className="text-success">Registration successful.</p>
            <p>Please check your email, for account verification.</p>
          </div>
        </div>
        <div className="flex justify-end">
          <Link to="/" className="text-info">Sign In</Link>
        </div>
      </Modal>
    </>
  );
}

export default withForm(withFormValidation(SignUp,
  {
    email: 'required|email',
    password: 'required|password',
    password_confirmation: 'required|min_eight|same:password',
    first_name: 'required',
    last_name: 'required',
    terms_and_condition: 'required',
    mobile_number: 'required|mobile_number'
  },
), initState);
